export const SUPPORTED_LOCALES = ["el", "en"] as const;
export type Locale = typeof SUPPORTED_LOCALES[number];

export function isSupportedLocale(locale: string): locale is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale);
}

export function normalizeLocale(locale?: string): Locale {
  if (!locale) return "el";
  return isSupportedLocale(locale) ? locale : "el";
}
